import { type ReactNode } from 'react';
import { Assert } from '@team/assert';

export function isPrimitiveNode(value: ReactNode): value is string | number {
  return Assert.isString(value) || Assert.isNumber(value);
}
